import { render, staticRenderFns } from "./prize-list.vue?vue&type=template&id=58bd6512&scoped=true&"
import script from "./prize-list.vue?vue&type=script&lang=js&"
export * from "./prize-list.vue?vue&type=script&lang=js&"
import style0 from "./prize-list.vue?vue&type=style&index=0&id=58bd6512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bd6512",
  null
  
)

export default component.exports